import React, {useEffect, useState} from 'react';
import {
  PREFER_INIT_LIVE_LIST,
  PREFER_INIT_VOD_LIST,
  SELECTED_MODE,
} from '@/constants/main';
import useMainStore from '@/stores/main';
import MyPlusApi from '@/api/main/my-plus';
import {LiveGroup} from '@/components/main/MyPlus/common/LiveGroup';
import {CategoryList} from '@/components/main/MyPlus/common/CategoryList';
import {TopBanner} from '@/components/main/MyPlus/common/TopBanner';
import CatchGroup from '@/components/main/MyPlus/common/CatchGroup';
import {VodGroup} from '@/components/main/MyPlus/common/VodGroup';
import {CatchStoryGroup} from '@/components/main/MyPlus/common/CatchStoryGroup';
import {getLocalStorage, setLocalStorage} from '@/utils/main';
import {PlayerArea} from '@/components/main/MyPlus/common/PlayerArea';
import {buildTopLiveList} from '@/utils/main/my-plus/topLiveListUtils';
import '/public/static/css/module/section.scss';

const PreferSection = ({mainListInfo, isSimplifyMode}) => {
  //데이터 로딩 상태
  const [isLoading, setIsLoading] = useState(false);

  //어드민 세팅 리스트(순서)
  const [adminSettingList, setAdminSettingList] = useState([]);
  //선호 Live 리스트
  const [preferLiveList, setPreferLiveList] = useState(PREFER_INIT_LIVE_LIST);
  //선호 Vod 리스트
  const [preferVodList, setPreferVodList] = useState(PREFER_INIT_VOD_LIST);
  const [preferTopLiveList, setPreferTopLiveList] = useState([]);
  //스트리밍 Live 리스트
  const {banner, setTopLiveList, isShowMainBanner, topLiveList} =
    useMainStore();

  const SECTION_CONFIG_MAP = {
    PREFER_PREVIEW: {
      component: PlayerArea,
      props: {
        banner: banner.main,
        selectedMode: SELECTED_MODE.PREFER,
        isLoading: isLoading,
      },
      isActive: !isShowMainBanner,
      isDivider: false,
    },
    PREFER_LIVE_01: {
      component: LiveGroup,
      props: {
        response: preferLiveList,
        selectedMode: SELECTED_MODE.PREFER,
        isLoading: isLoading,
      },
      isDivider: false,
    },
    PREFER_CATEGORY_01: {
      component: CategoryList,
      props: {
        selectedMode: SELECTED_MODE.PREFER,
      },
      isDivider: true,
    },
    MAIN_LIST_BNR_01: {
      component: TopBanner,
      props: {
        mainListInfo,
      },
      isDivider: true,
    },
    PREFER_CATCH_01: {
      component: CatchGroup,
      props: {
        selectedMode: SELECTED_MODE.PREFER,
      },
      isDivider: true,
    },
    PREFER_VOD_01: {
      component: VodGroup,
      props: {
        response: preferVodList,
        selectedMode: SELECTED_MODE.PREFER,
      },
      isDivider: false,
    },
    PREFER_STORY_01: {
      component: CatchStoryGroup,
      props: {},
      isDivider: true,
    },
    CINETY_01: {
      component: React.Fragment,
      props: {},
      isDivider: false,
    },
  };

  const fetchPreferApi = async (queryParams) => {
    const preferApi = MyPlusApi.getPreferLiveVodList;
    const adminApi = MyPlusApi.getAdminPreferSettingList;

    const [preferRes, adminRes] = await Promise.all([
      preferApi(queryParams),
      adminApi(),
    ]);

    return {preferRes, adminRes};
  };

  const getPreferSectionList = async () => {
    setIsLoading(true); // API 호출 시작 전에 로딩 상태를 true로 설정

    try {
      const nextRelationType = getLocalStorage('nextRelationType', '');
      const queryParams = {
        szRelationType: nextRelationType,
      };
      const {preferRes, adminRes} = await fetchPreferApi(queryParams);

      setAdminSettingList(adminRes);

      setLocalStorage('nextRelationType', preferRes.nextRelationType);

      setPreferLiveList({
        liveCnt: preferRes.liveCnt || 0,
        liveList: preferRes.liveList?.length > 0 ? preferRes.liveList : [],
      });

      setPreferVodList({
        vodCnt: preferRes.vodCnt || 0,
        vodList: preferRes.vodList?.length > 0 ? preferRes.vodList : [],
      });
      setPreferTopLiveList(preferRes?.topLiveList || []);
    } catch (error) {
      setAdminSettingList([]);
      setPreferLiveList({
        liveCnt: 0,
        liveList: [],
      });
      setPreferVodList({
        vodCnt: 0,
        vodList: [],
      });
      setPreferTopLiveList([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      preferTopLiveList?.length > 0 &&
      mainListInfo?.simplifymodeResult !== undefined
    ) {
      const filteredTopList = buildTopLiveList({
        selectedMode: SELECTED_MODE.PREFER,
        broadList: preferTopLiveList,
        isSimplifyMode,
        banner,
        topLiveList,
      });
      setTopLiveList(filteredTopList);
    }
  }, [preferTopLiveList, mainListInfo, isSimplifyMode, banner]);

  useEffect(() => {
    getPreferSectionList();
  }, []);

  return (
    <>
      {adminSettingList.map(({sectionCode, order}) => {
        const config = SECTION_CONFIG_MAP[sectionCode];
        if (!config) {
          return null;
        }

        const {
          component: SectionComponent,
          props,
          isActive = true,
          isDivider,
        } = config;
        return (
          isActive && (
            <section className={'prefer-wrapper'} key={sectionCode}>
              <SectionComponent {...props} order={order} />
              {isDivider && <i className={'divider'} />}
            </section>
          )
        );
      })}
    </>
  );
};

export default PreferSection;
